
interface User {
  piEmail: string;
  email: string;
}

interface App {
  irbApplicationId: string;
  applicationCode: string;
  irbTitle: string;
  typeOfReview: string;
  appStatus: string;
  user: User;
  piEmail: string;
  piFirstname: string;
  piPhoneNumber: string;
  createdDate: Date;
  piRole: string;
  piLastName: string;
  facultyRequestedDate: Date;
  facultyResuestedStatus: string;
  reviewerStatusDescription: string;
  notifcationStatus: string;
  notifcationType: string;
  reviewerAssignedDate: Date;
  submittedDate: Date;
  irbDate: Date;
  reviewerEmail: string;
  reviewerFirstName: string;
  reviewerLastName: string;
  notifcationAssignedUserEmail: string;
  notifcationAssigned: string;
  notificationId: string;
  notifcationAlertMessage: string;
  notifcationAlertMessageCreated: Date;
  notifcationCreatedDate: Date;
  transactionLogName: string;
  transactionLogAction: string;
  transactionLogInfo: string;
  transactionLogDate: Date;
  userId: string;
}

export interface Paging {
  page: number;
  recordsPerPage: number;
  pageCount: number;
  totalCount: number;
  defaultPage: number;
  typeOfReview: string;
  piEmail: string;
  appCode: string;
  appStatus: string;
  irbStatus: string;
  firstName: string;
  lastName: string;
  role: string;
}

import { defineComponent, ref, PropType, computed, onMounted } from "vue";
import moment from "moment";
import { Field } from "vee-validate";
import ApplicationTableActionFilter from "./ApplicationTableActionFilter.vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "table-action",
  components: {
    Field,
    ApplicationTableActionFilter,
  },
  methods: {
    executeAction(info, action) {
      action(info);
    },
    executeActionDecision(info, actionDecision) {
      actionDecision(info);
    },
    moment(date) {
      if (date == null) {
        return "";
      }
      return moment(date).local().fromNow();
    },
    momentMDY(date) {
      if (date == null) {
        return "";
      }
      return moment(date).format("MMM DD, YYYY");
    },
    momentHour(date) {
      if (date == null) {
        return "";
      }
      return moment(date).format("HH:mm:ss a");
    },
  },
  props: {
    list: Array as PropType<Array<App>>,
    tableColumns: Array as PropType<Array<string>>,
    functionToCall: Object,
    functionToCallDecision: Object,
    functionToCallName: String,
    pagination: Object as PropType<Paging>,
    tableCallFunction: String,
    researchTitle: String,
    hiddeSearchBar: Boolean,
    hiddeFilterButton: Boolean,
    hideRadio: Boolean,
  },

  setup(props) {
    const store = useStore();
    const tableCallAFunction: string = props.tableCallFunction!;
    const titleSearchRetuls = computed(() => {
      return store.getters.currentIrbAppTitleFilter;
    });

    const paging = ref<Paging>({
      page: 1,
      recordsPerPage: 8,
      pageCount: 0,
      totalCount: 0,
      defaultPage: 1,
      appCode: "",
      irbStatus: "",
      piEmail: "",
      typeOfReview: "",
      appStatus: "",
      firstName: "",
      lastName: "",
      role: "",
    });
    const recordsPerPage = computed(() => {
      return props.pagination?.recordsPerPage || 8;
    });

    onMounted(() => {
      store.dispatch(tableCallAFunction != null ? tableCallAFunction : "", {
        params: {
          Page: paging.value.page,
          RecordsPerPage: recordsPerPage.value,
          title: titleSearchRetuls?.value,
        },
      });
    });

    const changePage = function (e) {
      store.dispatch(tableCallAFunction != null ? tableCallAFunction : "", {
        params: {
          Page: e,
          RecordsPerPage: recordsPerPage.value,
          title: titleSearchRetuls?.value,
          TypeOfReview:
            props.pagination?.typeOfReview == "all"
              ? ""
              : props.pagination?.typeOfReview,
          PiEmail: props.pagination?.piEmail,
          AppCode: props.pagination?.appCode,
          AppStatus:
            props.pagination?.appStatus == "all"
              ? ""
              : props.pagination?.appStatus,
          IrbStatus:
            props.pagination?.irbStatus == "all"
              ? ""
              : props.pagination?.irbStatus,
          firstname: props.pagination?.firstName,
          lastname: props.pagination?.lastName,
          role: props.pagination?.role,
        },
      });
    };

    const changeRows = function (e) {
      store.dispatch(tableCallAFunction != null ? tableCallAFunction : "", {
        params: {
          Page: 1,
          RecordsPerPage: e.currentTarget ? e.currentTarget.value : e,
          title: titleSearchRetuls?.value,
          TypeOfReview:
            props.pagination?.typeOfReview == "all"
              ? ""
              : props.pagination?.typeOfReview,
          PiEmail: props.pagination?.piEmail,
          AppCode: props.pagination?.appCode,
          AppStatus:
            props.pagination?.appStatus == "all"
              ? ""
              : props.pagination?.appStatus,
          IrbStatus:
            props.pagination?.irbStatus == "all"
              ? ""
              : props.pagination?.irbStatus,
          firstname: props.pagination?.lastName,
          lastname: props.pagination?.firstName,
          role: props.pagination?.role,
        },
      });
    };

    return {
      store,
      changePage,
      tableCallAFunction,
      changeRows,
      recordsPerPage,
    };
  },
});
